import { memo, useState } from "react";
import { useTypedSelector } from "hooks";
import { ConfirmatableDialog, type ConfirmatableDialogProps } from "ui/molecules/Dialog"
import DialogContent from "./DialogContent";
import { Setup } from "features/setups/types";
import { selectIsSetupLoading } from "features/setups/selectors";
import { updateOrCreateSetupGrupPivot } from "features/setups/api";
import useGeneralActions from "features/general/useActions";
import { NotificationSeverity } from "features/general/types";


type Props = {
    row: Setup<string>
} & Pick<
    ConfirmatableDialogProps,
    'open' | 'onClose'
>;

const CreateGroupDialog = ({ open, onClose, row }: Props) => {
    const isLoading = useTypedSelector(selectIsSetupLoading);
    const [selectedGroupName, setSelectedGroupName] = useState<string | null>(row.groupName);
    const { showNotication } = useGeneralActions();

    const onCancel = () => onClose?.();
    const updateGroupName = (groupName: string | null) => {
        setSelectedGroupName(groupName);
    }
    const onConfirm = async () => {
        await updateOrCreateSetupGrupPivot({
            groupName: selectedGroupName!,
            identifier: row.identifier,
        }).then(() => showNotication({
            message: `Group ${selectedGroupName} created successfully`,
            severity: NotificationSeverity.Success
        })
        )
        onCancel()
    };

    const dialogContent = {
        dialogContent: [
            <DialogContent
                row={row}
                updateGroupName={updateGroupName}
                selectedGroupName={selectedGroupName}
            />
        ],
        actionContent: 'Create Group'
    };

    return (
        <ConfirmatableDialog
            content={[
                dialogContent,
                dialogContent
            ]}
            cancelActionContentSlot='Cancel'
            isProcessing={isLoading}
            open={open}
            checkPredicate={() => false}
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
};

export default memo(CreateGroupDialog);